import { ListableCategoryBasicResponse } from '@bluestone-node-sdk/pim';
import { makeAutoObservable } from 'mobx';
import getCompanyList from './fn/getCompanyList';
import { CategoryBasicResponse } from '@bluestone-node-sdk/keycloak-mgmtv3';
import getCompanyByUserNumber from './fn/getCompanyByUserNumber';
import loadCompanyList from './fn/loadCompanyList';

export default class CompanyStore {
    companyList: ListableCategoryBasicResponse['data'] = [];
    isGettingCompanyList: boolean = false;
    selectedSlagId: string = '';
    selectedCompany: CategoryBasicResponse = {};

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isGettingCompanyList = false;
        this.companyList = [];
        this.selectedCompany = {};
        this.selectedSlagId = '';
    }

    setGettingCompanyList(value: typeof this.isGettingCompanyList) {
        this.isGettingCompanyList = value;
    }

    setCompanyList(companies: typeof this.companyList) {
        this.companyList = companies;
    }

    setSelectedSlagId = (slagId: typeof this.selectedSlagId) => {
        this.selectedSlagId = slagId;
    };

    setSelectedCompany = (company: typeof this.selectedCompany) => {
        this.selectedCompany = company;
    };

    getCompanyList = getCompanyList;
    getCompanyByUserNumber = getCompanyByUserNumber;
    loadCompanyList = loadCompanyList;
}
